// --- Project role ---
export var ProjectRole;
(function (ProjectRole) {
    ProjectRole["OWNER"] = "owner";
    ProjectRole["EDITOR"] = "editor";
    ProjectRole["VIEWER"] = "viewer";
})(ProjectRole || (ProjectRole = {}));
export var StatusMessageType;
(function (StatusMessageType) {
    StatusMessageType["INFO"] = "info";
    StatusMessageType["WARNING"] = "warning";
    StatusMessageType["ERROR"] = "error";
    StatusMessageType["STREAM"] = "stream";
})(StatusMessageType || (StatusMessageType = {}));
/**
 * Канонические ключи иконок проектов и сессий (единый список для server и UI).
 * Значения — только ключи реестра (загружаемые картинки не поддерживаются).
 */
export const PROJECT_ICON_KEYS = [
    'code',
    'terminal',
    'rocket',
    'flask',
    'gamepad',
    'briefcase',
    'home',
    'globe',
    'leaf',
    'shield',
    'palette',
    'server',
    'phone',
    'database',
    'lightbulb',
    'music',
    'camera',
    'book',
    'heart',
    'folder',
    'chat',
    'cpu',
    'file',
    'file-code',
    'docs',
    'task',
    'todo',
    'bug',
    'robot',
    'brain',
    'git',
    'repo',
    'test',
    'chart',
    'star',
    'image',
    'calendar',
];
/**
 * Канонические ключи цветов проектов и сессий — 16 цветов палитры темы
 * (`palette.colors[].key` в `a1..a16`; единый список для server и UI).
 */
export const PROJECT_COLOR_KEYS = [
    'a1', 'a2', 'a3', 'a4',
    'a5', 'a6', 'a7', 'a8',
    'a9', 'a10', 'a11', 'a12',
    'a13', 'a14', 'a15', 'a16',
];
